export enum StepButtonTypeEnum {
  Next = 0,
  Cancel = 1,
  PreviewEmailBody = 2,
}
